<template>
	<div class="index">
		<!-- 新闻中心 -->
		<div class="index_top">
			<div class="news">
				<Title titleName="新闻中心" titleNameEnglish="new Center" @goDetail="goNews('/news', 'xwzx')">
				</Title>
				<div class="news_content">
					<div class="news_content_item">
						<!-- 轮播图 -->
						<div class="swiper mySwiper">
							<div class="swiper-wrapper">
								<div @click="goNewsDetail(item, 'xwzx', item.class_id)" class="swiper-slide"
									v-for="item in home_banner">
									<img :src="item.sz_img" alt="">
									<div class="whyr_content_left_pic_title">
										<div class="whyr_content_left_pic_title_title">{{ item.title }}
										</div>
									</div>
								</div>

							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<!-- 新闻列表 -->
					<div class="news_right">
						<div class="news_right_title">
							<div @click="changeNewsNum(1,newList1)" class="news_right_title_item" :style="{backgroundColor:NewsNum==1?'#CB272B':''}">
								党建要闻
							</div>
							<div @click="changeNewsNum(2,newList2)"  :style="{backgroundColor:NewsNum==2?'#CB272B':''}" class="news_right_title_item">
								思政动态
							</div>
							<div @click="changeNewsNum(3,newList3)"  :style="{backgroundColor:NewsNum==3?'#CB272B':''}" class="news_right_title_item">
								党建风采
							</div>
							<div @click="changeNewsNum(4,newList4)"  :style="{backgroundColor:NewsNum==4?'#CB272B':''}" class="news_right_title_item">
								校园文化
							</div>
							<div @click="changeNewsNum(5,newList5)"  :style="{backgroundColor:NewsNum==5?'#CB272B':''}" class="news_right_title_item">
								教师风采
							</div>

						</div>
						<div class="news_right_content">
							<div v-for="item in newList" @click="goNewsDetail(item,'xwzx', NewsNum)" class="news_right_content_item">
								<div class="news_right_content_item_top">
									<img src="../../assets/zhuozi/zhuozi_day.png" alt="">
									<span>{{ item.pub_time }}</span>
								</div>
								<div class="news_right_content_item_bottom">
									{{ item.title}}
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="home_wrap">
            <!-- 政策解读/特色资源 -->
			<div class="InterpretationAndResources">
				<!-- 政策解读 -->
				<div class="Interpretation">
					<!-- 标题 -->
					<Title titleName="政策解读" titleNameEnglish="Policy Interpretation" @goDetail="goNews('/zcjd', 'zcjd')">
					</Title>
					<!-- 内容 -->
					<div class="Interpretation_content">
						<div class="shizheng_right_item" @click="goTzggDetail(item.id, 'zcjd')" v-for="item in home_zcjd"
							:key="item.id">
							<div class="shizheng_right_item_left">
								<div class="mouth">{{ item.addtime.substring(0,4) }}</div>
								<div class="year">{{ item.addtime.substring(5,10) }}</div>
							</div>
							<div class="shizheng_right_item_right">
								<div class="title_top">
									<div class="title_top_left">
										{{ item.title }}{{ item.title }}
									</div>
									<div class="title_top_left_right">
										{{ item.addtime }}
									</div>
								</div>
								<div class="content_bottom">{{ item.content }}</div>
							</div>
						
						</div>
					</div>
				</div>
				<!-- 活动风采-->
				<div class="zhuozi_active">
					<!-- 标题 -->
					<Title @goDetail="goNews('/news', 'hdfc')" titleName="活动风采" titleNameEnglish="Characteristic Resources">
					</Title>
					<div class="zhuozi_active_content">
                         <div class="zhuozi_active_content_item" v-for="item in newActive"  @click="goNewsDetail(item, 'hdfc', 1)">
                             <div class="active_left">
								<img :src="item.sz_img" alt="">
							 </div>
							<div class="zhuozi_active_right">
								<div class="title_top">
									<div class="title_top_left">
										{{ item.title }}
									</div>
									<div class="title_top_left_right">
										{{ item.pub_time }}
									</div>
								</div>
								<div class="content_bottom">
									{{ item.title }}
								</div>
							</div>
						 </div>
					</div>
				</div>
			</div>
             <!-- 成果展示通知公告 -->
            <div class="home_message">
                   <div class="home_message_item">
                        <div class="home_message_item_top">
                            <img src="../../assets/zhuozi/achievent.png" alt="">
						</div>
						<div class="achievent_item">
							<div class="Announcement_content_item" @click="goNewsDetail(item,'cgzs',item.type)"
							v-for="item in home_cgzs" :key="item.id">
									<div class="left_circle"></div>
									<div class="center_title">{{ item.title }}{{ item.title }}{{ item.title }}</div>
									<div class="right_time">{{ item.pub_time }}</div>
						     </div>
						   <div class="achievent_item_getmore" @click="goNews('/news', 'cgzs')">
							  <img src="../../assets/zhuozi/getMore.png" alt="">
						   </div>
						</div>
				   </div>
				   <!-- 通知公告 -->
				   <div class="home_message_item">
						<div class="achievent_item">
							<div class="Announcement_content_item" @click="goTzggDetail(item.id, 'tzgg')"
							v-for="item in home_tzgg" :key="item.id">
									<div class="left_circle"></div>
									<div class="center_title">{{ item.title }}</div>
									<div class="right_time">{{ item.pub_time }}</div>
						     </div>
							
						<div class="achievent_item_getmore" @click="goNews('/tzgg', 'tzgg')">
							<img src="../../assets/zhuozi/getMore.png" alt="">
						</div>
						</div>
						<div class="home_message_item_top">
                            <img src="../../assets/zhuozi/zhuozi_notice.png" alt="">
						</div>
				   </div>
			</div>
			<!-- 本校资源 -->
			<div class="schoolResouce">
				<Title titleName="本校资源" titleNameEnglish="Party Building" @goDetail="goSpeaial(13)">
				</Title>
				<div class="schoolResouce_content">
                    <div class="schoolResouce_content_item" @click="goSpeaial(16,item.id)" v-for="item in home_bxzy">
						 <div class="schoolResouce_pic">
							    <img :src="item.sz_img" alt="">
						 </div>
						 <div class="schoolResouce_title">
							{{ item.title }}
						 </div>
					</div>
				</div>
			</div>
            <!-- 特色专题 -->
			<Title2 titleName="特色专题" titleNameEnglish="Party Building" @goDetail="goNews('/tszt', 'tszt')">
			</Title2>
			<div class="speaial">
				<div class="speaial_item" @click="goSpeaial(1)" >
					<img src='../../assets/zhuozi/speacial01.png' alt="">
				</div>
				<div class="speaial_item">
					<router-link target="_blank" :to="{path:'/hsqj?index=6'}">
						<img src='../../assets/zhuozi/speacial02.png' alt=""></router-link>
					
				</div>
				<div class="speaial_item"   @click="goSpeaial(3)" >
					<img src='../../assets/zhuozi/speacial03.png' alt="">
				</div>
				<div class="speaial_item" @click="goSpeaial(4)">
					<img src='../../assets/zhuozi/speacial04.png' alt="">
				</div>
				<div class="speaial_item" @click="goSpeaial(5)" >
					<img src='../../assets/zhuozi/speacial05.png' alt="">
				</div>
				<div class="speaial_item" @click="goSpeaial(14)" >
					<img src='../../assets/zhuozi/speacial06.png' alt="">
				</div>
				<div class="speaial_item" @click="$router.push({path:'/xsx'})" >
					<img src='../../assets/zhuozi/speacial07.png' alt="">
				</div>
				<div class="speaial_item" >
					<img src='../../assets/zhuozi/speacial08.png' @click="goSpeaial(8)" alt="">
				</div>
			</div>
		</div>

	</div>
</template>
<script>
import Swiper from 'swiper';
import { shouye } from '@/axios';
import Title from '@/components/title.vue'
import Title2 from '@/components/title2.vue'
import { Message } from 'element-ui'
export default {
	data() {
		return {
			tsszSrc: '',
			tsszTitle: '',
			NewsNum: 1,
			home_banner: [],
			// 本校资源
			home_bxzy:[],
			// 活动风采
			newActive: [],
			// 政策解读
			home_zcjd:[],
            // 成果展示
			home_cgzs:[],
            // 通知公告
			home_tzgg: [],
            

           newList:[],

			newList1: [],
			newList2: [],
			newList3: [],
			newList4: [],
			newList5: [],
			thearList: [],
			home_djbk: [],
			home_tssz: [],
			home_tjdj: [],
			
			home_dwgk: [],
			// 弹出框按钮
			centerDialogVisible: false
		}
	},
	components: { Title,Title2 },
	methods: {
		// 习思想
		goXsx() {
			
			this.$router.push({ path: 'xsx' })
		},
		// 新闻中心/实践活动
		goNews(path, type, id) {
			
			this.$router.push({
				path: path,
				query: {
					type: type,
					class_id: id
				}
			})
		},
		goTssz() {
			
		
			this.$router.push({
				path: '/tssz',

			})
		},
		// 点击新闻中心切换标题
		changeNewsNum(val,arr) {
			this.NewsNum = val
			this.newList=arr
		},
		//    初始化轮播图
		swiper() {
			
			var swiper = new Swiper(".mySwiper", {
				autoplay: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
			});
		},
		// 获取首页数据
		getHomeList() {
			
			let that = this
			shouye.homelist().then((res) => {
				
				if (res.code == 200) {
					that.home_banner = res.data.banner
					that.home_bxzy = res.data.bxzy
                    that.home_zcjd = res.data.zcjd
                    that.newActive = res.data.hdfc
					that.home_cgzs=res.data.cgzs
					that.home_cgzs.forEach((item,index,arr) => {
						if (item.pub_time.indexOf("-") == -1) {
							arr[index].pub_time=that.$changeTime(item.pub_time)
						}
					});
					that.home_tzgg = res.data.tzgg
					that.newList=res.data.news1
					that.newList1 = res.data.news1
					that.newList2 = res.data.news2
					that.newList3 = res.data.news3
					that.newList4 = res.data.news4
					that.newList5 = res.data.news5
					// 初始化轮播图
					this.$nextTick(() => {
								that.swiper()
					})
					that.thearList = res.data.thear
					that.home_djbk = res.data.djbk
					that.home_dwgk = res.data.dwgk
				}

			})
		},
		// 跳转至新闻详情
		goNewsDetail(data, type, class_id) {
			this.$router.push({
				path: '/xwxq',
				query: {
					id: data.id,
					type: type,
					class_id: class_id,
					xwType:data.type
				}
			})
		},
		// 跳转至通知公告详情
		goTzggDetail(id, type,typeNum) {
			this.$router.push({
				path: '/tzgg_detail',
				query: {
					id: id,
					type: type,
					typeNum:typeNum
				}
			})
		},
		tsszDetail(data) {
			this.tsszTitle = data.title
			this.tsszSrc = data.sz_img
			this.centerDialogVisible = true
		},
		// 跳转至图解党建详情
		goTjdjDetail(id) {
			
			this.$router.push({
				path: 'tidj_detail',
				query: {
					id: id
				}
			})
		},
		// 跳转至特色资源详情
		goZyDetail(path) {
			
			this.$router.push({ path: path })
		},
		// 跳转至党建百科
		goDjbk(id) {
			
			this.$router.push({
				path: 'djbk',
				query: {
					class_id: id
				}
			})
		},
		// 专题
		goSpeaial(index,zyid){
              this.$router.push({
				path:'/special',
				query:{
					id:index,
					zyid:zyid
				}
			  })
		}
	},
	mounted() {
		this.getHomeList()

		

	},
	created() {
		this.$emit("highLight", 1, "", "", "");
		
		
	}
}
</script>

<style lang="scss" >
@import '@/common/index.scss';

.index {
	width: 100%;

	div {
		box-sizing: border-box;
	}

	//  新闻中心
	.index_top {
		width: 100%;
		height: 440px;
		background-image: url(../../assets/zhuozi/news_bg.png);
		background-size: 100% 100%;

		.news {
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			box-sizing: border-box;
			padding-top: 24px;

			.news_content {
				display: flex;
				justify-content: space-between;
				margin-top: 16px;
				height: 336px;

				.news_content_item {
					width: 588px;
					height: 336px;
					border-radius: 8px;
					overflow: hidden;

					/* 轮播图样式 */
					.swiper {
						width: 100%;
						height: 100%;
						position: relative;

						.swiper-slide {
							border-radius: 4px;
							overflow: hidden;
							text-align: center;
							font-size: 18px;
							background: #fff;
							/* Center slide text vertically */
							display: -webkit-box;
							display: -ms-flexbox;
							display: -webkit-flex;
							display: flex;
							-webkit-box-pack: center;
							-ms-flex-pack: center;
							-webkit-justify-content: center;
							justify-content: center;
							-webkit-box-align: center;
							-ms-flex-align: center;
							-webkit-align-items: center;
							align-items: center;

							img {
								display: block;
								width: 100%;
								height: 100%;
								object-fit: cover;
							}

							.whyr_content_left_pic_title {
								height: 36px;
								width: 100%;
								position: absolute;
								left: 0;
								bottom: 0;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
								padding-left: 20px;
								background-color: rgba(0, 0, 0, 0.3);

								.whyr_content_left_pic_title_title {
									width: 80%;
									height: 100%;
									overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
									font-family: PingFangSC-Regular;
									font-size: 14px;
									font-weight: normal;
									line-height: 36px;
									letter-spacing: 0px;
									color: #FFFFFF;
								}

							}

						}

						.swiper-pagination {
							position: absolute;
							bottom: 16px;
							justify-content: right !important;
							align-items: center !important;
							text-align: right !important;
							color: #fff;

						}

						.swiper-pagination-bullet {
							opacity: 0.4;
							width: 8px !important;
							height: 8px !important;
							background: #FFFFFF !important;
							margin-right: 6px;
							margin-left: 0px !important;
						}

						.swiper-pagination-bullet-active {
							opacity: 1;
							background: #fff !important;
							width: 8px !important;
							height: 8px !important;

						}
					}


				}

				// 右侧新闻列表
				.news_right {
					box-sizing: border-box;
					padding-right: 16px;

					width: 588px;
					height: 336px;
					display: flex;
					justify-content: space-between;
					border-radius: 8px;
					background: rgba(255, 255, 255, 0.2);
					backdrop-filter: blur(20px);
					overflow: hidden;

					.news_right_title {
						width: 180px;
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						.news_right_title_item {
							height: 64px;
							background-color: #BE4041;
							font-family: PingFangSC-Regular;
							font-size: 16px;
							font-weight: normal;
							line-height: 64px;
							text-align: center;
							letter-spacing: 0.1em;
							color: #fff;

						}
					}

					.news_right_content {
						width: 368px;
						height: 100%;

						.news_right_content_item {
							width: 100%;
							height: 68px;
							border-bottom: 1px dashed #CB272B;
							box-sizing: border-box;
							padding: 10px 0;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							.news_right_content_item_top{
								height: 16px;
								display: flex;
								align-items: center;
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								line-height: 16px;
								display: flex;
								align-items: center;
								letter-spacing: 0px;
								color: #DAB3B3;
								img{
									height: 16px;
									width: 16px;
								}
								span{
									margin-left: 10px;
								}
							}
							.news_right_content_item_bottom{
								width: 100%;
								height: 24px;
								font-family: PingFangSC-Regular;
								font-size: 14px;
								font-weight: normal;
								line-height: 24px;
								text-align: justify; /* 浏览器可能不支持 */
								letter-spacing: 0px;
								color: #FFFFFF;
								white-space: nowrap;
								text-overflow: ellipsis;
								overflow: hidden;
							}
						}
					}
				}
			}
		}
	}
	.home_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;
         // 政策解读及特色资源
		.InterpretationAndResources {
			margin-top: 30px;
			margin-bottom: 40px;
			width: 100%;
			height: 336px;
			display: flex !important;
			justify-content: space-between;
			// 政策解读
			.Interpretation {
				width: 588px;
				height: 100%;
				.Interpretation_content {
					width: 100%;
					margin-top: 20px;
					.shizheng_right_item {
						position: relative;
						height: 72px;
						width: 100%;
						border-bottom:  1px dashed #ECEEF4;
						display: flex;
						justify-content: space-between;
						overflow: hidden;

						.shizheng_right_item_left {
							height: 100%;
							width: 64px;
							padding: 8px 0;
							margin-right: 10px;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							.year {
                                width: 64px;
								height: 24px;
								background-image: url(../../assets/zhuozi/zhuozi_year.png);
								font-family: PingFangSC-Regular;
								font-size: 18px;
								font-weight: normal;
								text-align: center;
								letter-spacing: 0px;
								color: #fff;
							}

							.mouth {
								font-family: PingFangSC-Regular;
								font-size: 14px;
								font-weight: normal;
								text-align: center;
								letter-spacing: 0px;
								color: #F1842B;
							}
						}

						.shizheng_right_item_right {
							height: 100%;
							width: 793px;
							padding: 8px 0 8px 20px;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
                            box-sizing: border-box;
							.title_top {
								display: flex;
								justify-content: space-between;
								width: 100%;
								font-family: PingFangSC-Regular;
								font-size: 14px;
								font-weight: normal;
								letter-spacing: 0px;
								color: #000000;
								
								.title_top_left{
                                  width: 410px;
								  overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
								}
								.title_top_left_right{
									font-size: 12px;
									color: #9E9E9E;

								}
							}

							.title_top:hover {
								color: #EE632B;
								font-weight: 800;
							}

							.content_bottom {
								width: 100%;
								height: 32px;
								font-family: MicrosoftYaHei;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0px;
								color: #999999;
								line-height: 16px;
								overflow: hidden;
								text-overflow: ellipsis;
								-webkit-line-clamp: 2;
								display: -webkit-box;
								-webkit-box-orient: vertical;
							}
						}

					

					}
				}


			}

			//活动风采
			.zhuozi_active {
				width: 588px;
				height: 100%;
                .zhuozi_active_content{
					width: 100%;
					height: 288px;
					margin-top: 20px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.zhuozi_active_content_item{
						width: 100%;
						height: 84px;
						display: flex;
						.active_left{
							width: 148px;
							height: 100%;
							border-radius: 8px;
							overflow: hidden;
							img{
								width: 100%;
								height: 100%;
							}
						}
						.zhuozi_active_right {
							height: 100%;
							width: 424px;
							padding: 8px 0 8px 20px;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
                            box-sizing: border-box;
							.title_top {
								display: flex;
								justify-content: space-between;
								width: 100%;
								font-family: PingFangSC-Regular;
								font-size: 14px;
								font-weight: normal;
								letter-spacing: 0px;
								color: #000000;
								.title_top_left{
                                  width: 320px;
								  overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
								}
								.title_top_left_right{
									font-size: 12px;
									color: #9E9E9E;

								}
							}

							.title_top:hover {
								color: #EE632B;
								font-weight: 800;
							}

							.content_bottom {
								width: 100%;
								height: 40px;
								font-family: MicrosoftYaHei;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0px;
								color: #999999;
								line-height: 20px;
								overflow: hidden;
								text-overflow: ellipsis;
								-webkit-line-clamp: 2;
								display: -webkit-box;
								-webkit-box-orient: vertical;
							}
						}
					}
				}
			}
		}
        // 成果展示及通知公告
        .home_message{
			width: 100%;
			height: 356px;
			display: flex;
			justify-content: space-between;
            .home_message_item{
               width: 588px;
			   height: 100%;
			   .home_message_item_top{
				width: 100%;
				height: 120px;
				img{
					width: 100%;
					height: 100%;
				}
			   }
			   .Announcement_content_item {
						height: 40px;
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						.left_circle {
							height: 8px;
							width: 4px;
							border-radius:233px;
							background-color: #EE632B;
						}
						.center_title {
							font-family: PingFangSC-Regular;
							font-size: 14px;
							font-weight: 400;
							line-height: 20px;
							letter-spacing: 1px;
							color: #000000;
							margin-right: 40px;
							overflow: hidden;
							height: 20px;
							width:420px;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.center_title:hover {
							color: #EE632B;
							font-weight: 800;
						}
						.right_time {
							width: 100px;
							font-family: MicrosoftYaHei;
							font-size: 12px;
							font-weight: normal;
							line-height: 20px;
							text-align: right;
							letter-spacing: 0px;
							color: #999999;
						}
				}
				.achievent_item_getmore{
					width: 100%;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					img{
						width: 48px;
						height: 11px;
					}
				}
			}

		}
        // 本校资源
		.schoolResouce {
			width: 100%;
			margin-top: 30px;
			margin-bottom: 30px;
            .schoolResouce_content{
				width: 100%;
				height: 160px;
				margin-top: 16px;
				display: flex;
				.schoolResouce_content_item{
					width: 224px;
					height: 160px;
					margin-right: 20px;
					border-radius: 8px;
					border: 1px solid #ECEEF4;
					.schoolResouce_pic{
						width: 100%;
						height: 128px;
						img{
							width: 100%;
							height: 100%;

						}
					}
					.schoolResouce_title{
						width: 100%;
						height: 32px;
						box-sizing: border-box;
						padding: 0 10px;
						line-height: 32px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						line-height: 32px;
						letter-spacing: 0em;
						color: #000000;
					}
				}
				.schoolResouce_content_item:nth-child(5n){
					margin-right: 0;
				}
			}
		

		}
		.speaial{
			margin-top: 16px;
			margin-bottom: 30px;
			width: 100%;
			height: 288px;
			display: flex;
			flex-wrap: wrap;
			.speaial_item{
				width: 282px;
				height: 136px;
				margin-right: 20px;
				margin-bottom: 20px;
				
				img{
					width: 100%;
					height: 100%;
				}
			}
			.speaial_item:nth-child(4n){
				margin-right: 0;
			}
		}

	}
	
}</style>
